import React from 'react'
import PropTypes from 'prop-types'

const QuestionSvg = ({ color = '#582ACB' }) => {
  return (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill={color}
        d="M9.747 16.086c0-1.192.142-2.142.426-2.85.284-.707.844-1.482 1.68-2.325.844-.851 1.378-1.456 1.602-1.814.344-.547.517-1.138.517-1.774 0-.843-.203-1.483-.608-1.922-.396-.448-.982-.673-1.757-.673-.74 0-1.34.22-1.796.66-.448.43-.671 1.016-.671 1.76H6c.017-1.586.534-2.84 1.55-3.764C8.575 2.461 9.928 2 11.607 2c1.732 0 3.08.457 4.044 1.371.974.914 1.46 2.19 1.46 3.83 0 1.461-.655 2.9-1.964 4.315l-1.589 1.627c-.568.671-.861 1.653-.878 2.943H9.747zm-.22 4.18c0-.528.16-.954.478-1.277.319-.331.75-.497 1.292-.497.551 0 .986.17 1.305.51.319.332.478.753.478 1.264 0 .493-.155.905-.465 1.237-.31.331-.75.497-1.318.497-.568 0-1.008-.166-1.318-.497-.301-.332-.452-.744-.452-1.237z"
      />
    </svg>
  )
}

QuestionSvg.propTypes = {
  color: PropTypes.string
}

export default QuestionSvg
